import { Extension } from '@tiptap/core';
// eslint-disable-next-line import/extensions
import { Plugin, PluginKey } from '@tiptap/pm/state';

export default Extension.create({
    name: 'Readonly',

    addGlobalAttributes() {
        return [
            {
                types: ['tableHeader', 'tableCell'],
                attributes: {
                    readonly: {
                        default: false
                    }
                }
            }
        ];
    },

    addProseMirrorPlugins() {
        return [
            new Plugin({
                key: new PluginKey('readonly'),
                props: {
                    editable(state) {
                        const isReadonly = state.selection.$head.path.some(v => {
                            try {
                                return v.attrs.readonly === true;
                            } catch (error) {
                                return false;
                            }
                        });

                        return !isReadonly;
                    }
                }
            })
        ];
    }
});
